import React, { Fragment } from 'react';

import Routes from './route/routes';

import './App.sass';
import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import ErrorHandler from './utils/error-handler';

function App() {
  return (
    <Fragment>
       <ErrorHandler>        
          <Routes />
      </ErrorHandler>
    </Fragment>
  );
}

export default App;
